import Api from "../axios";

export const getRewardDetails = async (id) => {
  return await Api.get(`/Global/Plan?planId=${id}`);
};
